import React, { Component } from 'react';
import Pica from 'pica';
import classnames from 'classnames';

import APIClient from './Api';
import { getImageUrl } from '../ImageUtils';

const api = new APIClient();
const pica = Pica();


class HomeTestimonial extends Component {
  /* Single Home Testimonial */

  constructor(props) {
    super(props);
    this.imagePreview = React.createRef();
    this.imageBuffer = new Image();
    this.imageBuffer.crossOrigin = "Anonymous";   // Enables images loading for local dev
    this.imageBuffer.addEventListener('load', this.handleImageLoaded, false);
    this.imageBuffer.src = getImageUrl(props.data.image);
  }

  handleFieldChange = (event) => {
    const target = event.target;
    if (target != null) {
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const name = target.name;
      this.props.onFieldChange(name, value);
    }
  }

  handleImageChange = (event) => {
    const target = event.target;
    var files = target.files;

    if (files.length === 0) { return; }

    this.imageBuffer.src = window.URL.createObjectURL(files[0]);
    this.props.onFieldChange("filename", files[0].name);
  }

  handleImageLoaded = (event) => {
    const squareDimension = 158;
    var offScreenCanvas = document.createElement('canvas');
    // If the given image is too large: crop.
    // i.e. its minimum dimension will be our square's dimension
    if (this.imageBuffer.width > this.imageBuffer.height) {
      offScreenCanvas.width = squareDimension * this.imageBuffer.width / this.imageBuffer.height;
      offScreenCanvas.height = squareDimension;
    } else {
      offScreenCanvas.width = squareDimension;
      offScreenCanvas.height = squareDimension * this.imageBuffer.height / this.imageBuffer.width;
    }

    pica.resize(this.imageBuffer, offScreenCanvas, {alpha: true})
      .then(result => pica.toBlob(result, 'image/png', 0.90))   // png to preserve transparency
      .then(blob => {
        var blobReader = new FileReader();
        blobReader.addEventListener("loadend", () => {
          // Pass raw data to parent
          this.props.onImageChange(blobReader.result);
        });
        blobReader.readAsDataURL(blob);
        console.log('resized to canvas & created blob!');
        // Draw image, centered in the canvas
        let canvas = this.imagePreview.current;
        let ctx = canvas.getContext('2d', {alpha: true});
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(
          offScreenCanvas,
          -(offScreenCanvas.width - squareDimension) / 2,
          -(offScreenCanvas.height - squareDimension) / 2
        );
      });
  }

  render() {
    let filename = this.props.data.filename !== undefined ? this.props.data.filename : '';
    return (
      <div>
        <div className="field gp-home-testimonial-img">
          { /* Be careful: the same CSS class (gp-temoignage-img) is used in the web site */ }
          <div className="gp-temoignage-img">
            <canvas ref={this.imagePreview} width="158" height="158"/>
          </div>
          <div className={classnames("file", filename !== '' ? "has-name" : "")}>
            <label className="file-label">
              <input className="file-input" type="file" name="image" onChange={this.handleImageChange}/>
              <span className="file-cta">
                <span className="file-icon">
                  <i className="fas fa-upload"></i>
                </span>
                <span className="file-label">
                  Modifier l'image
                </span>
              </span>
              { filename !== '' ?
                <span className="file-name">
                  {filename}
                </span>
                : ''
              }
            </label>
          </div>
        </div>
        <div className="field">
          <label className="label">
            Prénom<span className="gp-mandatory"/>
          </label>
          <div className="control">
            <input
              className="input"
              type="text"
              name="title"
              maxLength="20"
              placeholder="20 caractères maximum"
              onChange={this.handleFieldChange}
              onBlur={this.handleFieldChange}
              value={this.props.data.title}
            />
          </div>
        </div>
        <div className="field">
          <label className="label">
            Texte<span className="gp-mandatory"/>
          </label>
          <div className="control">
            <textarea
              className="textarea"
              name="message"
              maxLength="200"
              placeholder="200 caractères maximum"
              onChange={this.handleFieldChange}
              onBlur={this.handleFieldChange}
              value={this.props.data.message}
            ></textarea>
          </div>
        </div>
      </div>
    )
  }
}


class HomeTestimonials extends Component {

  constructor(props) {
    super(props);
    this.state = {
      testimonials: null,
      saved: false,
      error: false
    }
  }

  async componentDidMount() {
    await this.fetchData();
  }

  async fetchData() {
    const data = await api.getBackOfficeHomeTestimonials();
    this.setState({
      testimonials: data
    });
  }

  handleFieldChange = (index, fieldName, fieldValue) => {
    let testimonials = this.state.testimonials;
    testimonials[index][fieldName] = fieldValue;
    this.setState({
      testimonials: testimonials,
      saved: false,
      error: false
    });
  }

  handleImageChange = (index, imageRawData) => {
    let testimonials = this.state.testimonials;
    if (testimonials[index]["filename"] !== undefined && testimonials[index]["filename"] !== "") {
      // If this is an actual upload, store raw image data in state
      console.log('new image loaded, ' + testimonials[index]["filename"]);
      testimonials[index]["imageData"] = imageRawData;
      this.setState({
        testimonials: testimonials,
        saved: false,
        error: false
      });
    } else {
      // First loading of image: don't store it in state
      console.log('image first load');
    }
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    let testimonials = this.state.testimonials;
    try {
      for (var testimonialData of testimonials) {
        let res = await api.updateBackOfficeHomeTestimonial(testimonialData.id, testimonialData);
        // Substitute image raw data with url from server
        delete testimonialData.imageData;
        testimonialData.image = res.image;
        testimonialData.filename = "";
      }
      this.setState({
        testimonials: testimonials,
        saved: true,
        error: false
      });
    } catch(e) {
      console.log(e);
      this.setState({
        saved: false,
        error: true
      });
    }
  }

  isTestimonialValid(testimonial) {
    return testimonial.title !== '' && testimonial.message !== ''
  }

  render() {
    return (
      <div className="">
        <form onSubmit={this.handleSubmit}>
            { this.state.testimonials != null ?
              (
                <div>
                  <div className="columns">
                    {
                    this.state.testimonials.map((testimonialData, index) =>
                      <div className="column">
                        <div className="box">
                          <HomeTestimonial
                            data={testimonialData}
                            onFieldChange={this.handleFieldChange.bind(this, index)}
                            onImageChange={this.handleImageChange.bind(this, index)}
                            />
                        </div>
                      </div>
                    )
                    }
                  </div>
                  <div className="field">
                    <button
                      type="button"
                      onClick={this.handleSubmit}
                      className="button is-link gp-button-form-submit"
                      disabled={!this.state.testimonials.every(x => this.isTestimonialValid(x))}
                     >
                      Sauvegarder
                    </button>
                  </div>
                  {
                    this.state.saved && !this.state.error ? (
                      <div className="field">
                        <p className="help is-success">Sauvegarde réussie, les modifications seront visibles sur le site dans quelques minutes</p>
                      </div>) : ''
                  }
                  {
                    this.state.error ? (
                      <div className="field">
                        <p className="help is-danger">Une erreur s'est produite lors de la sauvegarde, veuillez réessayer ultérieurement</p>
                      </div>) : ''
                  }
                </div>
              ) : ''
            }
        </form>
      </div>);
  }
}

export default HomeTestimonials;
